module.exports = __webpack_public_path__ + "static/media/spining-loader.cefd21cb.svg";